export default {
      id: "move-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#move",
      toString: function () {
        return this.url;
      }
    }